import { EventEmitter, Injectable, Output, Directive } from "@angular/core";

@Directive()
@Injectable()
export class PrintDocumentService {

  @Output() public changed: EventEmitter<any> = new EventEmitter();

  public changeMade() {
    this.changed.emit({
      change: true,
    });
  }

}
